import React from 'react';

interface FacebookIconProps {
  className?: string;
}

const FacebookIcon: React.FC<FacebookIconProps> = ({ className }) => (
  <i
    className={['fa-brands fa-facebook', className].filter(Boolean).join(' ')}
    aria-hidden="true"
  />
);

export default FacebookIcon;
